<template>
  <div class="access">
    <div class="wrap">
      <div class="describe">
        <!-- <p>英泽传媒 给您分享了云相册</p> -->
        <p>给您分享了云相册</p>
        <p>{{activityTitle}}</p>
      </div>
      <div class="pw-container">
        <form>
          <p>请输入访问密码：</p>
          <input class="pw-input" type="password" name="password" v-model="accessCode" @keydown.enter="check">
          <div class="error" v-show="showTips"><span class="glyphicon glyphicon-info-sign"></span>密码错误</div>
          <input class="pw-btn" type="button" value="进入相册" @click="check">
          <!-- 能消除密码框回车刷新界面的BUG -->
          <input type="text" style="display:none" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      accessCode: '',
      activityTitle: sessionStorage.getItem(this.$md5(this.$route.params.id + 'title')),
      showTips: false,
      activityId: this.$route.params.id
    }
  },
  methods: {
    check () {
      Vue.axios.post('/api/activity/accessCheck', {
        id: this.$route.params.id,
        accessCode: this.accessCode
      }).then(({ status, data }) => {
        //console.log(data)
        if (status === 200 && data && data.result === true) {
          sessionStorage.setItem(this.$md5(this.activityId), '')
          this.showTips = false
          this.$router.push({ name: 'activity', params: { id: this.$route.params.id } })
        } else {
          sessionStorage.setItem(this.$route.params.id, 'false')
          this.showTips = true
        }
      })
    }
  }

}
</script>
